import Header from 'components/headers/easyPay'
import InitGatewayPayment from 'modules/easyPay/init/indexGatewayPayment'

export default function InitGatewayPaymentPage() {
    return (
        <div className=" h-screen relative">
            <Header title="پرداخت آسان درگاهی" />
            <InitGatewayPayment />
        </div>
    )
}
